export default __webpack_public_path__ + "dd7ad77d0b967d6ef168da5626db68bf.svg";